import React from 'react';
import '../../styles/requestConfirmed.css';
import {Redirect} from 'react-router-dom'

export default class RequestDeclined extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            viewOrders : false
        }

    }

    handleviewOrdersClick(){
        this.setState({
            viewOrders : true
        })
    }
    render() {

        if(this.state.viewOrders){
            return(
                <Redirect push to = "/orders"/>
            )
        }
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    REQUEST DECLINED
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>
                            <div className="col-sm-6 UploadPaintingCard text-center ">
                                <img className="success-gold" src={require("../../assets/Success_black_png.png")}/>

                                <p className="success-text">
                                    You have successfully declined the buy request. we will contact you in case there is another buy request.
                                </p>

                                <button className="masterpieces-primary-buttons btn-primary height-48 p-35 mb-25" onClick={this.handleviewOrdersClick.bind(this)}>
                                    View All Orders
                                </button>

                            </div>

                        </div>

                    </div>
                </article>
            </div>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_modals/request_declined.js